import React from 'react';
import { formatExperimentsForEventAttributes } from '../elog/mparticle';
import { MParticleEventName } from '../elog/mparticle_tracker';
import experiments from '../experiments';
import { useExpEnabled, useUser } from '../user_hooks';
import { useViewTracking } from '../use_tracking';
import AppleSigninButton from './apple_signin_button';
import FacebookSigninButton from './facebook_signin_button';
import GoogleSigninButton from './google_signin_button';
import SigninSeparator from './signin_separator';

interface Props {
  redirectTo?: string;
  isSignup?: boolean;
}

export default function ThirdPartyAuthButtons(props: Props) {
  const googleAuthExpEnabled = useExpEnabled(experiments.GOOGLE_AUTH);
  const user = useUser();

  useViewTracking({
    eventName: MParticleEventName.ViewedThirdPartyAuthButtons,
    experiments: formatExperimentsForEventAttributes(user, [experiments.GOOGLE_AUTH]),
  }, true);

  return (
    <>
      <SigninSeparator />
      <div className="mt-1">
        <FacebookSigninButton
          isSignup={props.isSignup}
          redirectTo={props.redirectTo}
        />
      </div>
      <div className="mt-1">
        <AppleSigninButton
          isSignup={props.isSignup}
          redirectTo={props.redirectTo}
        />
      </div>
      { googleAuthExpEnabled &&
        <div className="mt-1">
          <GoogleSigninButton
            isSignup={props.isSignup}
            redirectTo={props.redirectTo}
          />
        </div>
      }
    </>
  );
}
